/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');
var Radio = require('backbone.radio');
var _get = require('lodash.get');

var GetApplicationDetails = require('../../../common/services/GetApplicationDetails');
var GetApplicationStatus = require('../../../common/services/GetApplicationStatus');

var ComplianceExaminerReviewAnnualReportTaskView = require('./ComplianceExaminerReviewAnnualReportTaskView');

module.exports = {
  event: 'build:nd:compliance-examiner-review-annual-report',

  channel: 'task',

  builder: function(task) {
    var defer = $.Deferred();

    var applicationId = _get(task, 'taskData.ND.applicationId');

    $.when(GetApplicationDetails(applicationId), GetApplicationStatus(applicationId))
      .done(function(applicationDetails, applicationStatus) {
        NProgress.set(0.5);

        applicationDetails.applicationStatus = applicationStatus.internalStatus;

        var applicationFormIdentifier = applicationDetails.formIdentifier;
        var applicationTypeId = applicationDetails.applicationTypeId;

        Radio.channel('nd:application')
          .request('build:' + applicationFormIdentifier, {
            applicationId: applicationId,
            applicationTypeId: applicationTypeId,
            isReadOnly: true,
            mode: 'int'
          })
          .done(function(applicationFormView, applicationStatus) {
            NProgress.set(0.85);

            applicationFormView.model.set('applicationDetails', applicationDetails);

            defer.resolve(
              new ComplianceExaminerReviewAnnualReportTaskView({
                applicationFormView: applicationFormView,
                model: new Backbone.Model({
                  taskId: task.taskId,
                  applicationId: applicationId,
                  task: task,
                  applicationDetails: applicationDetails
                })
              })
            );
          })
          .fail(function(err) {
            defer.reject(err);
          });
      })
      .fail(function(err) {
        defer.reject(err);
      });
    return defer.promise();
  }
};
